import { Injectable } from '@angular/core';
import { removeProps } from '@iqd/shared-quoting';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Apollo, gql } from 'apollo-angular';
import { DocumentNode } from 'graphql';
import { Map } from 'immutable';
import { catchError, map, Observable, of, switchMap } from 'rxjs';

const getSettings: DocumentNode = gql`
  query settings {
    settings {
      id
      key
      value
      description
    }
  }
`;

@Injectable()
export class SettingsEffects {
  // Listen for the 'LOAD_SETTINGS' action
  loadSettings$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType('LOAD_SETTINGS'),
      switchMap((action) => this.apollo.query<any>({ query: getSettings })),
      map(({ data }) => {
        const settingsList = data.settings.map((s) => {
          if (s.value === 'true' || s.value === 'false') {
            // automatically convert to Boolean type
            return [s.key, Boolean(s.value)];
          } else if (!isNaN(s.value)) {
            // automatically convert valid numbers to Number type
            return [s.key, Number(s.value)];
          } else {
            return [s.key, removeProps(s.value, '__typename')]; // remove __typename from objects
          }
        });
        const payload = Map(settingsList);
        return { type: 'LOAD_SETTINGS_SUCCESS', payload };
      }),
      catchError((err) => of({ type: 'LOAD_SETTINGS_FAILURE', payload: err }))
    )
  );

  constructor(private actions$: Actions, private apollo: Apollo) {}
}
